import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const DialogComponent = React.lazy(() => import("../Components/RootComponents/DialogComponent"));
const DialogPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <DialogComponent />
      </Suspense>
    </Fragment>
  );
};

export default DialogPage;
